import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTheme } from './contexts/ThemeContext';
import { useFont } from './contexts/FontContext';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthSuccess from './pages/AuthSuccess';
import BetaLanding from './pages/BetaLanding';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Courses from './pages/Courses';
import Quiz from './pages/Quiz';
import Statistics from './pages/Statistics';
import QuizSession from './pages/QuizSession';
import Profile from './pages/Profile';
import ModuleDetail from './pages/ModuleDetail';
import CourseContent from './pages/CourseContent';
import Pricing from './pages/Pricing';
import TermsOfService from './pages/TermsOfService';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminDashboard from './pages/AdminDashboard';
import Hero from './components/Hero';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import BookmarkBanner from './components/BookmarkBanner';
import VaeAuxPuericulture from "./pages/VaeAuxPuericulture.tsx";
import Vae from "./pages/Vae.tsx";
import PetiteEnfance from "./pages/PetiteEnfance.tsx";
import FAQPetiteEnfance from "./pages/FaqPetiteEnfance.tsx";

function App() {
  const { theme } = useTheme();
  const { font } = useFont();


  return (
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
        <div className="min-h-screen flex flex-col" style={{ fontFamily: font.family }}>
          <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/vae-auxiliaire-de-puericulture" element={<VaeAuxPuericulture />} />
            <Route path="/vae" element={<Vae />} />
            <Route path="/petite-enfance" element={<PetiteEnfance />} />
            <Route path="/faq" element={<FAQPetiteEnfance />} />
            <Route path="/auth/success" element={<AuthSuccess />} />
            <Route path="/cours/:code/:courseId" element={<ProtectedRoute><CourseContent /></ProtectedRoute>} />
            <Route path="/cours/:code" element={<ProtectedRoute><ModuleDetail /></ProtectedRoute>} />
            <Route path="/cours" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute allowFreeAccess={true}><Dashboard /></ProtectedRoute>} />
            <Route path="/tarifs" element={<Pricing />} />
            <Route path="/qcm" element={<ProtectedRoute><Quiz /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
            <Route path="/qcm/session" element={<ProtectedRoute><QuizSession /></ProtectedRoute>} />
            <Route path="/profil" element={<ProtectedRoute requiresSubscription={false}><Profile /></ProtectedRoute>} />
            <Route path="/cgu" element={<TermsOfService />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<ProtectedRoute requiresSubscription={false}><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <BookmarkBanner />
      </div>
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;